module.exports = __webpack_public_path__ + "static/media/paragraph-rtl.0919c773.svg";